import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const mainBackendURL = import.meta.env.VITE_SERVER_URL;
export const gameBackendURL = import.meta.env.VITE_SERVER_GAME_URL;

export const gameApi = createApi({
  reducerPath: 'gameApi',
  baseQuery: fetchBaseQuery({
    baseUrl: gameBackendURL ?? mainBackendURL,
    prepareHeaders: (headers, { getState }) => {
      const state = getState() as { game: { token: string } };
      const token = state.game.token;
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: () => ({}),
});
